export interface Authorizations {
  ASSETS: AuthorizationLevel[];
  STRUCTURE: AuthorizationLevel[];
  USER: AuthorizationLevel[];
  MASS_EDIT: AuthorizationLevel[];
  SWAGGER: AuthorizationLevel[];
  IMAGE_EDITOR: AuthorizationLevel[];
}

export enum AuthorizationLevel {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  SHOW = 'SHOW',
}
